<template>
    <div id="apply-to-join-layout">
        <loading :loading="loading" :full-page="true"/>
        <section id="beach-section">
            <div class="container">
                <h1>Benefits unlike <br>any other stock library</h1>
                <div id="benefits-row">
                    <div class="benefit">
                        <strong>50%</strong>
                        <span>Commission</span>
                    </div>
                    <div class="d-inline-block plus">+</div>
                    <div class="benefit">
                        <span>Talent fee</span>
                        <span>paid by us</span>
                    </div>
                    <div class="d-inline-block plus">+</div>
                    <div class="benefit">
                        <span>We'll tag</span>
                        <span>your images</span>
                    </div>
                </div>
            </div>
        </section>
        <section id="signup-section" class="dark">
            <div class="container">
                <div id="apply-row" class="row">
                    <div class="col-sm-12 col-lg-5">
                        <h2 class="btn-color">Let's chat!</h2>
                        <p>
                            We're looking for local {{ locale === 'nz' ? 'New Zealand' : 'Australian' }} lifestyle <br class="d-none d-lg-block">photographers with an entrepreneurial streak.
                            <br><br>
                            Our clients range from the creative <br class="d-none d-lg-block">sector through to Government departments and <br class="d-none d-lg-block">the private sector across {{ locale === 'nz' ? 'Aotearoa' : 'Australia' }}.
                            <br><br>
                            We provide guidance on what's in demand <br class="d-none d-lg-block">and help you create in demand content.
                            <br><br>
                            Fill in the form and we'll get back to you shortly <br class="d-none d-lg-block">about next steps.
                        </p>
                    </div>
                    <div class="col-sm-12 col-lg-6 offset-lg-1">
                        <form id="application" class="needs-validation" @submit.prevent="applyNow" @keydown="form.onKeydown($event)">
                            <input id="upload-hash" type="hidden" name="upload-hash" value="">
                            <div class="form-row">
                                <div class="form-group col-md-6  col-sm-12">
                                    <label for="first-name" class="sr-only">First Name</label>
                                    <input id="first-name" v-model="form.name" type="text" class="form-control" placeholder="First Name" autocomplete="off" :class="{ 'is-invalid': form.errors.has('name') }">
                                    <has-error :form="form" field="name"/>
                                </div>
                                <div class="form-group col-md-6  col-sm-12">
                                    <label for="last-name" class="sr-only">Last Name</label>
                                    <input id="last-name" v-model="form.last_name" type="text" class="form-control" placeholder="Last Name" autocomplete="off" :class="{ 'is-invalid': form.errors.has('last_name') }">
                                    <has-error :form="form" field="last_name"/>
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="form-group col-md-12">
                                    <label for="email" class="sr-only">Email</label>
                                    <input id="email" v-model="form.email" type="email" class="form-control" placeholder="Email" autocomplete="off" :class="{ 'is-invalid': form.errors.has('email') }">
                                    <has-error :form="form" field="email"/>
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="form-group col-md-12">
                                    <label for="website" class="sr-only">{{ locale === 'nz' ? 'Link to Professional Portfolio' : 'Website / Instagram Handle' }}</label>
                                    <input id="website" v-model="form.website" type="text" class="form-control" :placeholder="locale === 'nz' ? 'Link to Professional Portfolio' : 'Website / Instagram Handle'" autocomplete="off" :class="{ 'is-invalid': form.errors.has('website') }">
                                    <has-error :form="form" field="website"/>
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="form-group col-md-12">
                                    <label for="region" class="sr-only">Region you are based in</label>
                                    <input id="region" v-model="form.region" type="text" class="form-control" placeholder="Region you are based in" autocomplete="off" :class="{ 'is-invalid': form.errors.has('region') }">
                                    <has-error :form="form" field="region"/>
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="form-group col-lg-8 col-md-12 check-group-col">
                                    <b-form-checkbox
                                        id="agree"
                                        v-model="form.privacy_policy"
                                        class="form-check"
                                        :class="{ 'is-invalid': form.errors.has('privacy_policy') }"
                                        name="privacy_policy"
                                    >
                                        I have read and agree to the
                                        <a :href="$router.resolve({ name: 'privacy-policy' }).href" style="font-weight: bold" @click.prevent="$bvModal.show('privacy-policy-modal')">
                                            Privacy Policy
                                        </a>
                                    </b-form-checkbox>
                                    <has-error :form="form" field="privacy_policy"/>
                                </div>
                                <div class="form-group col-lg-4 col-md-12 text-lg-right">
                                    <button type="submit" class="btn btn-primary">
                                        Submit
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </section>
        <section id="contributor-profile-pictures">
            <div class="container">
                <div class="row">
                    <div class="col-sm-12">
                        <h2>Join our growing community of <br class="d-block d-sm-none">diverse local photographers.</h2>
                        <img :src="`${assetsUrl}static-backgrounds/contributor-profiles.jpg`" class="w-100" />
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import Form from 'vform'
import Swal from 'sweetalert2'
import Loading from '~/components/global/Loading.vue'

export default {
    components: {
        Loading
    },
    data () {
        return {
            form: new Form({
                name: '',
                surname: '',
                email: '',
                website: '',
                privacy_policy: false,
                region: null,
                token: null
            }),
            submitText: null,
            loading: false
        }
    },
    head () {
        const title = 'How to become a Truestock Contributor'
        const description = this.locale === 'nz' ? 'Passionate about capturing authentic Aotearoa life? We\'re looking for a limited number of photographers and videographers, to become our co-owners.' : 'Passionate about capturing authentic Australian life? We\'re looking for a limited number of photographers to become our contributors.'

        return {
            title,
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: description
                },
                {
                    hid: 'og:title',
                    property: 'og:title',
                    content: title
                },
                {
                    hid: 'twitter:title',
                    name: 'twitter:title',
                    content: title
                },
                {
                    hid: 'og:description',
                    property: 'og:description',
                    content: description
                },
                {
                    hid: 'twitter:description',
                    name: 'twitter:description',
                    content: description
                }
            ]
        }
    },
    methods: {
        applyNow () {
            this.loading = true

            this.form.post('/contributor-application/apply')
                .then(() => {
                    Swal.fire({
                        icon: 'success',
                        title: 'Thanks for reaching out',
                        html: 'We will be in touch soon.',
                        confirmButtonText: 'OK'
                    })

                    this.form.reset()
                })
                .catch((e) => {
                    if (e.response.status !== 422) {
                        Swal.fire({
                            icon: 'error',
                            title: 'Something went wrong',
                            html: 'Please refresh the page and try again',
                            confirmButtonText: 'OK'
                        })
                    }
                })
                .finally(() => {
                    this.submitText = true
                    this.loading = false
                })
        }
    }
}
</script>
